<span class="tag purple" *ngIf="offerService.isDubbleOffered(matchingOffer, side)" (click)="searchOffer($event)">複数提案中</span>
<span class="tag red" *ngIf="offerService.isInterviewing(matchingOffer)">面談中</span>
<span class="tag red" *ngIf="offerService.isSucceeded(matchingOffer)">成立</span>
<span class="tag black" *ngIf="offerService.isFailed(matchingOffer)">不成立</span>
<span class="tag black" *ngIf="offerService.isCancelled(matchingOffer)">取消</span>

<span class="tag" *ngIf="offerService.isWaitingQuery(matchingOffer, side)">未連絡</span>
<span class="tag green" *ngIf="offerService.isChecking(matchingOffer, side)">回答待ち</span>
<span class="tag orange" *ngIf="offerService.isApproved(matchingOffer, side)">承諾</span>
<span class="tag black" *ngIf="offerService.isRejected(matchingOffer, side)">辞退</span>
